import * as React from 'react';

const ArrowChevronLeftSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M12.1544 3.68164L5.83594 10.0001L12.1544 16.3186L13.3329 15.1401L8.19296 10.0001L13.3329 4.86015L12.1544 3.68164Z"
            fill="#161719"
        />
    </svg>
);

ArrowChevronLeftSvg.displayName = 'ArrowChevronLeftSvg';
export default ArrowChevronLeftSvg;
